import { createContext, useContext } from 'react';

import { UserActions, UserState } from '@/types/context/user.context';

export const UserStateContext = createContext<UserState | null>(null);
export const UserActionsContext = createContext<UserActions | null>(null);

export const useUserState = () => {
	const context = useContext(UserStateContext);

	if (!context) {
		throw new Error('useUserState must be used within UserStateContext.Provider');
	}

	return context;
};

export const useUserActions = () => {
	const context = useContext(UserActionsContext);

	if (!context) {
		throw new Error('useUserActions must be used within UserActionsContext.Provider');
	}

	return context;
};
